import { useCallback, useEffect, useState } from "react";
import { PenLine } from "lucide-react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { http, imgUrl } from "@/lib/api";
import { Container } from "./common";
import { ReviewDialog, Stars } from "./ReviewForm";

export default function Reviews({ product }) {
  const [list, setList] = useState([]);
  const [writing, setWriting] = useState(false);
  const [zoom, setZoom] = useState(null);
  const load = useCallback(() => http.get(`/products/${product.id}/reviews`).then((r) => setList(r.data)), [product.id]);
  useEffect(() => { load(); }, [load]);
  const avg = list.length ? list.reduce((s, r) => s + r.rating, 0) / list.length : 0;

  return (
    <Container className="py-12">
      <section data-testid="product-reviews">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <h2 className="font-display text-3xl font-bold">Avaliações</h2>
            {list.length > 0 ? (
              <p className="mt-2 flex items-center gap-2 text-sm"><Stars value={avg} testid="product-reviews-avg" /><b>{avg.toFixed(1)}</b><span className="text-[var(--muted-ink)]" data-testid="product-reviews-count">({list.length} {list.length === 1 ? "avaliação" : "avaliações"})</span></p>
            ) : <p className="mt-2 text-sm text-[var(--muted-ink)]" data-testid="product-reviews-empty">Ainda sem avaliações. Compraste este produto? Sê a primeira pessoa a avaliar.</p>}
          </div>
          <button data-testid="product-write-review-button" onClick={() => setWriting(true)} className="btn-ghost"><PenLine className="h-4 w-4" />Escrever avaliação</button>
        </div>
        {list.length > 0 && (
          <div className="mt-8 grid gap-5 md:grid-cols-2">
            {list.map((r) => (
              <article key={r.id} className="rounded-2xl border border-[var(--line)] bg-white p-5" data-testid={`review-${r.id}`}>
                <div className="flex items-center justify-between"><b>{r.name}</b><span className="text-xs text-[var(--muted-ink)]">{new Date(r.created_at).toLocaleDateString("pt-PT")}</span></div>
                <Stars value={r.rating} />
                <p className="mt-3 text-sm leading-relaxed text-[var(--muted-ink)]">{r.text}</p>
                {r.photos?.length > 0 && <div className="mt-3 flex gap-2">{r.photos.map((p) => <button key={p} onClick={() => setZoom(p)} className="h-20 w-20 overflow-hidden rounded-xl"><img src={imgUrl(p)} alt={`Foto de ${r.name}`} className="h-full w-full object-cover transition-transform hover:scale-105" /></button>)}</div>}
                <p className="mt-3 text-[10px] font-semibold uppercase tracking-wider text-[var(--violet)]">Compra verificada</p>
              </article>
            ))}
          </div>
        )}
      </section>
      {writing && <ReviewDialog product={product} onClose={() => setWriting(false)} />}
      {zoom && <Dialog open onOpenChange={() => setZoom(null)}><DialogContent className="max-w-3xl p-2"><img src={imgUrl(zoom)} alt="" className="max-h-[80vh] w-full rounded-lg object-contain" /></DialogContent></Dialog>}
    </Container>
  );
}
